export default "__VITE_ASSET__4c493b4b__"